export default "__VITE_ASSET__e5fa3e76__"